module.exports = __webpack_public_path__ + "img/login.ea51b477.svg";